import PropTypes from 'prop-types';
import React from 'react';

import cx from 'classnames';
import isEqual from 'is-equal';
import buildUrl from "build-url-ts";

import { Row, Col } from "react-bootstrap";
import InfiniteScroll from 'react-infinite-scroller';

import EventService from 'src/utils/event.service.jsx';

import SwitchButton from "src/components/switchButton";
import ChatUserRow from './chatUserRow/view.jsx';
import Nudges from './nudges';
import PlaceholderEmptyMessage from "src/components/placeholderEmptyMessage";
import RolodexEmptyMessageSvgIcon from "src/legacy/images/homeEmptyMessage.svg";

import styles from './styles.module.scss';
import _ from 'lodash';
import ChatUsersMapContainer from './map/index.jsx';
import { eq } from 'lodash';
import userRoleService from 'src/utils/userRoles.service.js';
import { localizedStrings } from 'src/localization/index.jsx';


class SmallTalkView extends React.Component {

  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);    

    this.state = {
      chatUsers: _.get(props, 'chatUsers'),
      global: _.get(this.props.location, 'query.global') === "true",
      filter: _.get(this.props.location, 'query.filter') || "all"
    }

    this.updateUrl = this.updateUrl.bind(this);
    this.handleNudgeChange = this.handleNudgeChange.bind(this);
    this.loadMoreChatUsers = this.loadMoreChatUsers.bind(this);
    this.handleGlobalRecipientToggle = this.handleGlobalRecipientToggle.bind(this);

    this.localizedEngage = localizedStrings.pages.engage;
    this.localizedCommons = localizedStrings.commons;
  }

  componentDidMount() {
    this.handleUrlChange(this.props);
    // clicked the engage page
    this.props.trackAdoptionMetricsForEngageClickedEvent();
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.chatUsers, nextProps.chatUsers)) {
      this.setState({
        chatUsers: _.get(nextProps, 'chatUsers')
      });
    }

    if (!_.isEqual(this.props.location, nextProps.location)) {
      this.handleUrlChange(nextProps);
    }
  }

  updateUrl(filter, global) {
    const url = buildUrl(this.props.location.pathname, {
      queryParams: {
        filter: filter,
        global: global
      }
    });

    this.props.navigate(url, { replace: true });  }

  handleUrlChange(props) {
    const global = _.get(props.location, 'query.global') === "true";
    const filter = _.get(props.location, 'query.filter') || "all";

    this.setState({
      filter: filter,
      global: global
    }, () => {
      this.props.fetchChatUsers(0, filter, global);
      this.props.fetchLocationsChatUsers(filter, global);
    });
  }

  handleGlobalRecipientToggle() {
    this.setState(
      (prevState) => ({ global: !prevState.global }),
      () => {
        this.props.trackAdoptionMetricsForAllRecipientsToggledEvent();
        this.updateUrl("all", this.state.global);
      }
    );
  }
  

  handleFilter(filter) {
    const filterName = EventService.getLegendName(filter);
    this.props.trackAdoptionMetricsForViewerFilterAppliedEvent(filterName);
    this.updateUrl(filter, this.state.global);
  }

  handleNudgeChange(nudge) {
    if (nudge.type === 'user_activity') {
      const id = _.get(nudge, 'chatUser.id');
      this.props.navigate(`/engage/${id}?filter=${this.state.filter}&global=${this.state.global}`);
    } else {
      this.updateUrl(nudge.id, false);
    }
  }

  loadMoreChatUsers() {
    let totalPages = this.props.totalPages;
    let currentPage = this.props.currentPage;
    let nextPage = currentPage + 1;

    if (this.props.loading || nextPage > totalPages) {
      return;
    }

    this.props.fetchChatUsers(nextPage, "", this.state.global);
  }

  renderMapRow() {
    return (
      <Row>
        <Col md={6}>
          <ChatUsersMapContainer />
        </Col>
        <Col md={6} className={styles.nudges}>
          <p className={styles.nudgeHeading}>{this.localizedEngage.description_card.title}</p>
          <Nudges selected={this.state.filter} onChange={this.handleNudgeChange} />
        </Col>
      </Row>
    )
  }

  renderEmptyMessage() {
    return (
      <div className={styles.emptyMessage}>
        {this.props.loading ? (`${this.localizedCommons.loading.loading}...` ): this.localizedEngage.chat_view.options.empty_message.no_activity}
      </div>
    )
  }

  renderChatEmptyMessage() {
    var message = this.localizedEngage.empty_message.no_recipients
    
    if(this.state.filter == "unread"){
      message = this.localizedEngage.empty_message.unread_chats
    } else if (this.state.filter == "live"){
      message = this.localizedEngage.empty_message.no_live_users
    }
    return (
      <PlaceholderEmptyMessage
        title={this.localizedEngage.empty_message.title}
        message={message}
        image={RolodexEmptyMessageSvgIcon}
        className={styles.chatEmptyMessage}
        visible={true}
      />
    );
  }

  renderHeading() {

    const localizedFilters = this.localizedEngage.viewers.filters
    var filter = _.get(this.props.location, 'query.filter');
    var filterName = '';
    if (eq(filter, "last_24_hours")){
      filterName =  localizedFilters.hours
    } else if(eq(filter, "last_week")){
      filterName=  localizedFilters.week
    } else if(eq(filter, "last_month")){
      filterName=  localizedFilters.month
    } else {
      filterName = ''
    }

    return (
      <div>
        {_.isEmpty(filterName) ? this.localizedEngage.viewers.title :this.localizedEngage.viewers.active_users +filterName}</div>
    )
  }

  renderUsersList() {

    var children = Array();

    this.state.chatUsers && this.state.chatUsers.forEach(chatUser => {
      children.push(
        <div className={styles.chatUsers}>
          <ChatUserRow
            detailView={true}
            key={chatUser.id}
            chatUser={chatUser}
            icon={chatUser.contactDTO ? chatUser.contactDTO.icon : null}
            global={this.state.global}
            filter={this.state.filter}
            trackAdoptionMetricsForRecipientSelectedEvent={this.props.trackAdoptionMetricsForRecipientSelectedEvent}
          />
        </div>
      )
    });

    return (
      <Row className={styles.usersList}>
      <Col sm={12} className={styles.headerContainer}>
        <p className={styles.usersListHeading}>{this.renderHeading()}</p>
        {userRoleService.canAccessGlobalRecipients() && (
        <div className={styles.toggleSection}>
        <SwitchButton
          id="global-recipient-toggle"
          className={styles.switchButton}
          handleCheck={this.handleGlobalRecipientToggle}
          checked={this.state.global}
        />
        <span className={styles.toggleSectionHeading}>
          {localizedStrings.formatString(this.localizedEngage.viewers.show_all_recipients, {
            accountName: this.props.account.name,
          })}
        </span>
        </div>
      )}
      </Col>
      <Col sm={12} className={styles.filters}>
        <p
          className={cx({
            [styles.active]: this.state.filter == "all" })}
          onClick={() => this.handleFilter("all")}>
          {this.state.global ? this.localizedCommons.recipients:this.localizedEngage.chat_view.options.my_recipients}
          {this.state.filter == "all" && !this.props.loading && this.props.totalRecords !== undefined && ` (${this.props.totalRecords})`}
        </p>
        <p
            className={cx({
              [styles.active]: this.state.filter == "live"
            })}
            onClick={() => this.handleFilter("live")}>
            {this.localizedEngage.viewers.options.live_users}
            {this.state.filter == "live" && !this.props.loading  && this.props.totalRecords !== undefined && ` (${this.props.totalRecords})`}
          </p>
          <p
            className={cx({
              [styles.active]: this.state.filter == "unread"
            })}
            onClick={() => this.handleFilter("unread")}>
            {this.localizedEngage.viewers.options.unread_chats}
            {this.state.filter == "unread" && !this.props.loading && this.props.totalRecords !== undefined &&` (${this.props.totalRecords})`}
          </p>
        </Col>
        <Row className={styles.listTitle}>
          <Col sm={3}>{this.localizedEngage.viewers.headers.name}</Col>
          <Col sm={3}>{this.localizedEngage.viewers.headers.account}</Col>
          <Col sm={2}>{this.localizedEngage.viewers.headers.last_active}</Col>
          <Col sm={4}>{this.localizedEngage.viewers.headers.location}</Col>
        </Row>
        <div className={styles.list}>
          <div className={styles.chatUsersList} ref={(element) => {
            this.scrollContainer = element;
          }}>
            {this.state.chatUsers && this.state.chatUsers.length > 0 &&
              <InfiniteScroll
                pageStart={0}
                initialLoad={false}
                hasMore={this.props.currentPage < this.props.totalPages}
                loadMore={this.loadMoreChatUsers}
                useWindow={false}
                threshold={20}
              >
                {children}
              </InfiniteScroll>
            }
            {this.props.loading && 
              <div className={styles.loading}>{`${this.localizedCommons.loading.loading}...`}</div>
            }
            {!this.props.loading && this.state.chatUsers && this.state.chatUsers.length == 0 && this.renderChatEmptyMessage()}
          </div>
        </div>
      </Row>
    )
  }

  render() {

    return (
      <div className={styles.background}>
        <Row className={styles.header}>
          <Col sm={12} className={styles.column}>
            <h1 className={styles.pageTitle}>
              <div className={styles.pageTitleContent}>
                <span>
                {this.localizedEngage.title}
                </span>
              </div>
            </h1>
            <p className={styles.subTitle}>
            {this.localizedEngage.sub_text}
            </p>
          </Col>
        </Row>
        <Row className={styles.body}>
          {this.renderMapRow()}
          {this.renderUsersList()}
        </Row>
      </div>
    )
  }
}

SmallTalkView.contextTypes = {
  store: PropTypes.object
}

export default SmallTalkView;